export enum SportsNewQueryKeys {
  SportsNew = "sportsNew",
  SportsSuspensions = "sportsSuspensions",
  SportWithTranslations = "sportsNew.withTranslations",
  SportMappings = "sportsNew.mappings",
}
